const plugin = {
  install(Vue) {
    Vue.filter(
      'ellipsis',
      (value, charsCountLeft, charsCountRight) =>
        `${value.slice(0, charsCountLeft)}…${
          charsCountRight ? value.slice(-1 * charsCountRight) : ''
        }`
    )
  }
}

export default plugin
